import {ActionTypes} from '../actions';
import {downloadFile} from '../../common/util/file';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'list': [],
  'filteredList': [],
  'pageSize': 20,
  'pageNumber': 0,
  'listDetail': [],
  'filteredDetailList': [],
  'pageSizeDetail': 20,
  'pageNumberDetail': 0,
};

const getPage = (list, pageNumber, pageSize) => {
  if (list.length <= pageSize) {
    return [...list];
  }
  if (list.length > (pageSize * (pageNumber + 1))) {
    return [...list].slice(
      (pageSize * pageNumber),
      (pageSize * (pageNumber + 1))
    );
  }
  return [...list].slice(pageNumber * pageSize);
};

export const setsHeadSales = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_SET_SALES]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_SET_SALES]: (state, action) => ({
      ...state,
      'list': action.response.data,
      'filteredList': [...getPage(action.response.data, 0, state.pageSize)],
      'loading': false,
    }),
    [ActionTypes.FETCHED_SET_SALES_FAILED]: (state, action) => ({
      ...state,
      'list': [],
      'filteredList': [],
      'loading': false,
    }),
    
    [ActionTypes.FILTER_SET_SALES]: (state, action) => ({
      ...state,
      'filteredList': state.list.filter((element) =>
        [
          element.code || '',
          element.origin || '',
        ].some((text) =>
          text.toLowerCase().includes(action.payload.toLowerCase()) || action.payload === ''
        )
      ),
    }),
    [ActionTypes.DELETE_SET_SALES_DATA]: () => ({
      ...state,
      'list': [],
      'filteredList': [],
      'loading': false,
      'pageSize': 20,
      'pageNumber': 0,
    }),
    [ActionTypes.CHANGE_SET_SALES_LIST_PAGE]: (state, action) => ({
      ...state,
      'pageNumber': action.payload,
      'filteredList': [...getPage(state.list, action.payload, state.pageSize)],
    }),
    [ActionTypes.CHANGE_SET_SALES_LIST_PAGE_SIZE]: (state, action) => ({
      ...state,
      'pageSize': action.payload,
      'pageNumber': 0,
      'filteredList': [...getPage(state.list, 0, action.payload)],
    }),
    [ActionTypes.DOWNLOADING_SET_SALE_FILE_FAILED]: (state, action) => ({
      ...state,
      'downloading': true,
    }),
    [ActionTypes.DOWNLOADED_SET_SALE_FILE]: (state, action) => {
      downloadFile(action.response.data);
      return ({
        ...state,
        'downloading': false,
      });
    },
    [ActionTypes.DOWNLOADED_SET_SALE_FILE_FAILED]: (state, action) => ({
      ...state,
      'downloading': false,
    }),
    [ActionTypes.FETCHING_SET_SALES_DETAIL]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_SET_SALES_DETAIL]: (state, action) => ({
      ...state,
      'listDetail': action.response.data,
      'filteredDetailList': [...getPage(action.response.data, 0, state.pageSize)],
      'loading': false,
    }),
    [ActionTypes.FETCHED_SET_SALES_DETAIL_FAILED]: (state, action) => ({
      ...state,
      'listDetail': [],
      'filteredDetailList': [],
      'loading': false,
    }),
    [ActionTypes.DELETE_SET_SALES_DETAIL_DATA]: () => ({
      ...state,
      'listDetail': [],
      'filteredDetailList': [],
      'loading': false,
    }),

    [ActionTypes.CHANGE_SET_SALES_DETAIL_LIST_PAGE]: (state, action) => ({
      ...state,
      'pageNumberDetail': action.payload,
      'filteredDetailList': [...getPage(state.listDetail, action.payload, state.pageSizeDetail)],
    }),
    [ActionTypes.CHANGE_SET_SALES_DETAIL_LIST_PAGE_SIZE]: (state, action) => ({
      ...state,
      'pageSizeDetail': action.payload,
      'pageNumberDetail': 0,
      'filteredDetailList': [...getPage(state.listDetail, 0, action.payload)],
    }),
    [ActionTypes.DOWNLOADING_SET_SALE_DETAIL_FILE]: (state, action) => ({
      ...state,
      'downloading': true,
    }),
    [ActionTypes.DOWNLOADED_SET_SALE_DETAIL_FILE]: (state, action) => {
      downloadFile(action.response.data);
      return ({
        ...state,
        'downloading': false,
      });
    },
    [ActionTypes.DOWNLOADED_SET_SALE_DETAIL_FILE_FAILED]: (state, action) => ({
      ...state,
      'downloading': false,
    }),
  })(state, action);
};
